























import { ChannelSettings, Poll, PollState } from 'shared/js/store/poll';
import { Component, Vue } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  computed: mapState('polls', ['settings', 'viewerVote'])
})
export default class VoteForm extends Vue {
  public loading: boolean = true;
  public sdk: any = null;
  public settings!: ChannelSettings;
  public viewerVote!: number | null;

  public showVoteId: number | null = null;

  public PollState: any = PollState;

  public get accentColor(): string {
    return this.settings.accentColor;
  }

  public get textColor(): string {
    return this.settings.textColor;
  }

  public get poll(): Poll | null {
    return this.settings.poll;
  }

  public get pollIsReady(): boolean {
    if (!this.poll) {
      return false;
    }

    return (
      this.poll.state >= PollState.VotingOpen &&
      this.poll.state < PollState.Over
    );
  }

  public get pollRows(): object {
    if (!this.poll) {
      return {};
    }

    const rows = this.poll.options.length <= 3 ? '1' : '2';
    return {
      gridTemplateColumns: 'repeat(6, 1fr)',
      gridTemplateRows: `repeat(${rows}, 1fr)`
    };
  }

  public pollOptionStyle(winner: number, idx: number, count: number): object {
    const style: { [key: string]: any } = {};

    if (!this.poll) {
      return style;
    }

    if (this.poll.state >= PollState.ResultsAvailable && winner === idx) {
      style.backgroundColor = this.accentColor;
      style.color = this.textColor;
    }

    if (idx < 3) {
      // The first three options always span 2 elements unless there are only 2 total optins.
      style.gridColumn = `span ${count === 2 ? '3' : '2'}`;
    } else {
      // There's probably a better way to codify these rules for the second line of options:
      // 4 options: |    |    |----|----|    |    |
      // 5 options: |    |----|----|++++|++++|    |
      // 6 options: |----|----|++++|++++|^^^^|^^^^|
      switch (count) {
        case 4:
          style.gridColumn = '3 / span 2';
          break;

        case 5:
          if (idx === 3) {
            style.gridColumn = '2 / span 2';
          } else if (idx === 4) {
            style.gridColumn = '4 / span 2';
          }
          break;

        case 6:
          style.gridColumn = 'span 2';
          break;

        default:
          break;
      }
    }

    return style;
  }

  public winnerStyle(winner: number, idx: number): object {
    const style: { [key: string]: any } = {};

    if (!this.poll) {
      return style;
    }

    if (this.poll.state >= PollState.ResultsAvailable && winner === idx) {
      style.backgroundColor = this.accentColor;
      style.color = this.textColor;
    }

    return style;
  }

  public percentage(idx: number): string {
    if (
      !this.poll ||
      this.poll.state !== PollState.ResultsAvailable ||
      this.poll.options.length <= idx ||
      this.poll.results.length <= idx
    ) {
      return '';
    }

    const sum = this.poll.results.reduce((s, val) => s + val, 0);
    if (sum === 0) {
      return '0%';
    }

    return `${Math.round((this.poll.results[idx] / sum) * 100)}%`;
  }

  public vote(idx: number) {
    if (!this.poll) {
      return;
    }

    if (this.viewerVote === idx || this.poll.state >= PollState.ResultsAvailable) {
      return;
    }

    this.$store.commit('polls/setViewerVote', idx);
    this.sdk.vote(this.poll.id, idx).catch(() => {
      this.$store.commit('polls/clearViewerVote');
    });
  }

  public created() {
    this.sdk = new this.$muxy.SDK();
  }
}
